import React, { MouseEvent } from 'react'
import styled from 'styled-components'
import { Icon } from 'components/base-ui'

interface BtnCircleProps {
  size?: string
  icon?: string
  iconSize?: string
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void
}

const BtnCircle = ({ size = '28px', icon = 'pencil-2', iconSize = '13px', ...rest }: BtnCircleProps) => {
  return (
    <Circle {...rest} className="button" size={size}>
      <Icon name={icon} size={iconSize} />
    </Circle>
  )
}

export default BtnCircle

const Circle = styled.div<BtnCircleProps & { size: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  border: 1px solid ${(p) => p.theme.colors.primary};
  border-radius: 50%;
  transition: 0.3s;

  i {
    transition: 0.3s;
    color: ${(p) => p.theme.colors.primary};
  }

  .touch &.touch,
  &:active {
    transition: 0s;
    background-color: ${(p) => p.theme.colors.primary};

    i {
      transition: 0s;
      color: white;
    }
  }
`
